import { ApplicationResultContent } from '../../components/ApplicationResultContent';

type ApplicationRejectedProps = {
  programName: string;
  backgroundImage?: string;
};

export const ApplicationRejected = (props: ApplicationRejectedProps) => {
  const { programName, backgroundImage } = props;

  return (
    <ApplicationResultContent
      title="Here's an update on your application"
      backgroundImage={backgroundImage}
      description={
        <div className='flex flex-col gap-4'>
          <div>
            Thank you for your interest in the {programName}! While you're not eligible at this
            time, we truly appreciate your enthusiasm and the time you put into applying.
          </div>
          <div>
            If you have any questions or would like guidance on future opportunities, please feel
            free to reach out to your CSR program lead or{' '}
            <a href='mailto:support@movingworlds.org' className='text-brand-500 underline'>
              contact us
            </a>{' '}
            at MovingWorlds - we'd love to stay connected!
          </div>
        </div>
      }
    />
  );
};
